var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box-style-breadcrumb card flex justify-content-center"},[_c('Breadcrumb',{attrs:{"model":_vm.items,"home":_vm.home}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }